import { InvalidFormatError, IOHelper, JSONHelper, toJSONAttributeUsage, UInt160AttributeModel, } from '@neo-one/client-common';
import { AttributeBase } from './AttributeBase';
import { AttributeUsage } from './AttributeUsage';
export class UInt160Attribute extends AttributeBase(UInt160AttributeModel) {
    constructor({ usage, value }) {
        super({ usage, value });
        this.size = IOHelper.sizeOfUInt8 + IOHelper.sizeOfUInt160;
    }
    static deserializeWireBase(options) {
        const { reader } = options;
        const { usage } = super.deserializeAttributeWireBase(options);
        if (usage !== AttributeUsage.Script) {
            throw new InvalidFormatError(`Expected attribute usage to be ${AttributeUsage.Script}. Received: ${usage}`);
        }
        const value = reader.readUInt160();
        return new this({ usage, value });
    }
    serializeJSON(_context) {
        return {
            usage: toJSONAttributeUsage(this.usage),
            data: JSONHelper.writeUInt160(this.value),
        };
    }
}

//# sourceMappingURL=UInt160Attribute.js.map
